import { h, Component } from "preact";
import Required from "./Required";
import Description from "./Description";
import { change, touch } from "redux-form";
import MultipleOptions from "./multipleOptions/MultipleOptions";

class MultipleOptionsField extends Component {
  constructor() {
    super();
    this.changeValue = this.changeValue.bind(this);
  }
  changeValue = options => {
    const { meta, formName, input, valueField = "name" } = this.props;
    meta.dispatch(touch(formName, input.name));
    const optionsString = options
      .filter(option => option.value)
      .map(option => {
        const value = option[valueField];
        return value;
      })
      .join("{|}");
    meta.dispatch(change(formName, input.name, optionsString));
  };
  render({
    input,
    options,
    label,
    description,
    required,
    disabled,
    meta: { touched, error, warning },
    valueField = "name",
    trackQuantity
  }) {
    let setOptions = options ? options.concat([]) : [];
    const value = input.value ? input.value : "";
    const selectedValues =
      value && typeof value === "string" ? value.split("{|}") : value;
    const newOptions = setOptions.map(option => {
      if (selectedValues.indexOf(option[valueField]) !== -1) {
        option.value = true;
      } else {
        option.value = false;
      }
      return { ...option };
    });

    return (
      <div class={touched && error ? "form-group has-error" : "form-group"}>
        <label for={input.name} class="form-label">
          {label} <Required required={required} />
        </label>
        <Description description={description} />
        <MultipleOptions
          options={newOptions}
          touched={touched}
          error={error}
          disabled={disabled}
          optionClicked={this.changeValue}
          selectedBadgeClicked={this.changeValue}
          trackQuantity={trackQuantity}
        />
        {touched && error && <p class="form-input-hint">{error}</p>}
      </div>
    );
  }
}

export default MultipleOptionsField;



// WEBPACK FOOTER //
// ./components/fields/MultipleOptionsField.js